import { hasRole, R, PAYROLL_STAFF, STAFF, TEAM_LEADS } from "../../../rbac/access";

export const PROFILE_TABS = [
  { id: "overview", label: "Overview" },
  { id: "personal", label: "Personal" },
  { id: "employment", label: "Employment" },
  { id: "organization", label: "Organization" },
  { id: "salary", label: "Salary & Packages" },
  { id: "attendance", label: "Attendance" },
  { id: "leave", label: "Leave" },
  { id: "payroll", label: "Payroll" },
  { id: "documents", label: "Documents" },
  { id: "statutory", label: "Statutory" },
  { id: "assets", label: "Assets" },
  { id: "lifecycle", label: "Lifecycle" },
  { id: "activity", label: "Activity" },
  { id: "settings", label: "Settings" },
];

/** Top-level groups; each sub-tab id must exist in PROFILE_TABS. */
export const PROFILE_TAB_GROUPS = [
  { id: "profile", label: "Profile", tabs: ["overview", "personal", "employment", "organization"] },
  { id: "time", label: "Attendance & Leave", tabs: ["attendance", "leave"] },
  { id: "pay", label: "Salary & Payroll", tabs: ["salary", "payroll", "statutory"] },
  {
    id: "records",
    label: "Documents & Other Details",
    tabs: ["documents", "assets", "lifecycle", "activity", "settings"],
  },
];

export function visibleProfileTabs(role) {
  return PROFILE_TABS.filter((tab) => canViewProfileTab(role, tab.id));
}

/** Groups with only the sub-tabs this role may see; empty groups are dropped. */
export function visibleProfileTabGroups(role) {
  const visible = visibleProfileTabs(role);
  return PROFILE_TAB_GROUPS.map((group) => ({
    ...group,
    tabs: group.tabs.map((id) => visible.find((t) => t.id === id)).filter(Boolean),
  })).filter((group) => group.tabs.length);
}

export function canViewProfileTab(role, tabId) {
  switch (tabId) {
    case "overview":
    case "personal":
    case "employment":
    case "organization":
      return hasRole(role, TEAM_LEADS.concat([R.FINANCE]));
    case "salary":
    case "payroll":
    case "statutory":
      return hasRole(role, PAYROLL_STAFF);
    case "attendance":
    case "leave":
      return hasRole(role, TEAM_LEADS.concat([R.FINANCE]));
    case "documents":
    case "lifecycle":
    case "activity":
      return hasRole(role, STAFF.concat([R.MANAGER, R.FINANCE]));
    case "assets":
      return hasRole(role, STAFF);
    case "settings":
      return hasRole(role, STAFF);
    default:
      return hasRole(role, TEAM_LEADS);
  }
}

export function canEditEmployee(role) {
  return hasRole(role, STAFF);
}

export function canManageSalary(role) {
  return hasRole(role, PAYROLL_STAFF);
}

export function canViewStatutorySensitive(role) {
  return hasRole(role, PAYROLL_STAFF);
}

export function canDeactivateEmployee(role) {
  return hasRole(role, STAFF);
}

export function canExportProfile(role) {
  return hasRole(role, TEAM_LEADS.concat([R.FINANCE]));
}
